import styled from 'styled-components';

export const Chip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(220, 53, 69, 0.14);
  border: 1px solid #dc3545;
  color: #fff;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 0.78rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(220, 53, 69, 0.28);
  }

  .live-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #dc3545;
    flex-shrink: 0;
    animation: academy-chip-pulse 1.2s infinite;
  }

  .material-icons {
    font-size: 16px;
  }

  @keyframes academy-chip-pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);
    }
    70% {
      box-shadow: 0 0 0 6px rgba(220, 53, 69, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
    }
  }
`;
